var callbacks = [];
var glueAsReady = undefined;
export function onGlueReady(callback) {
  if (glueAsReady) {
    callback(glueAsReady);
    return;
  }

  callbacks.push(callback);
  return function () {
    var number = callbacks.indexOf(callback);

    if (number > -1) {
      callbacks.splice(number, 1);
    }
  };
}
export function triggerGlueReady(glue) {
  glueAsReady = glue;
  callbacks.forEach(function (cb) {
    cb(glue);
  });
}